<div
  class="modal"
  id="editUserModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  #editForm
  (click)="dismiss($event)"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="row">
        <div class="modal-header" >
          <div class="modal-title">
            <p i18n="@@admin.users.title.manageusers">
              manage <b class="text-color">users</b>
            </p>
            <p class="pt-2 text-uppercase">
              <b class="text-color" i18n="@@admin.users.title.modifyuser"
                >Modify User</b
              >
            </p>
          </div>
          <i
            id="dismiss-btn"
            class="fas fa-times clickable"
            (click)="dismiss($event)"
          ></i>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="col-8 modalBodyContent">
            <form
              [formGroup]="addUserForm"
              (ngSubmit)="updateUser()"
              class="pt-5 formFrame"
            >
              <div class="row">
                <label class="col-2 formLabel" i18n="@@general.guid"
                  >Guid</label
                >
                <div class="md-form col-10 form-group">
                  <input
                    type="text"
                    formControlName="guid"
                    class="form-control no-bottom-border"
                    placeholder="guid"
                    [readonly]="true"
                  />
                </div>
              </div>

              <div class="row">
                <label class="col-5 formLabel" i18n="@@general.firstname"
                  >First name</label
                >
                <div class="md-form col-5 form-group">
                  <input
                    type="text"
                    formControlName="firstNameInput"
                    class="form-control"
                    placeholder="firstname"
                  />
                  <div
                    *ngIf="
                      form.firstNameInput.errors &&
                      (form.firstNameInput.dirty || form.firstNameInput.touched)
                    "
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="form.firstNameInput.errors.required"
                      i18n="@@validation.firstname.required"
                    >
                      First Name is required
                    </div>
                    <div
                      *ngIf="form.firstNameInput.errors.minlength"
                      i18n="@@validation.firstname.mustcontain2characters"
                    >
                      Must contain 2 characters
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <label class="col-5 formLabel" i18n="@@general.lastname"
                  >Last name</label
                >
                <div class="md-form col-5 form-group">
                  <input
                    type="text"
                    formControlName="lastNameInput"
                    class="form-control"
                    placeholder="name"
                  />
                  <div
                    *ngIf="
                      form.lastNameInput.errors &&
                      (form.lastNameInput.dirty || form.lastNameInput.touched)
                    "
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="form.lastNameInput.errors.required"
                      i18n="@@validation.lastname.required"
                    >
                      Last Name is required
                    </div>
                    <div
                      *ngIf="form.lastNameInput.errors.minlength"
                      i18n="@@validation.lastname.mustcontain2characters"
                    >
                      Must contain 2 characters
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <label class="col-5 formLabel" i18n="@@general.email"
                  >Email</label
                >
                <div class="md-form col-5 form-group">
                  <input
                    type="text"
                    formControlName="mailInput"
                    class="form-control"
                    placeholder="name@mail.com"
                  />
                  <div
                    *ngIf="
                      form.mailInput.errors &&
                      (form.mailInput.dirty || form.mailInput.touched)
                    "
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="form.mailInput.errors.required"
                      i18n="@@validation.email.required"
                    >
                      Email is required
                    </div>
                    <div
                      *ngIf="form.mailInput.errors.email"
                      i18n="@@validation.email.invalid"
                    >
                      Email is invalid
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <label class="col-5 formLabel" i18n="@@general.phone.short"
                  >Tel</label
                >
                <div class="md-form col-5 form-group">
                  <input
                    type="text"
                    formControlName="telInput"
                    class="form-control"
                    placeholder="phone number"
                  />
                  <div
                    *ngIf="
                      form.telInput.errors &&
                      (form.telInput.dirty || form.telInput.touched)
                    "
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="form.telInput.errors.required"
                      i18n="@@validation.phone.required"
                    >
                      PhoneNumber is required
                    </div>
                    <div
                      *ngIf="form.telInput.errors.pattern"
                      i18n="@@validation.phone.invalid"
                    >
                      PhoneNumber is invalid
                    </div>
                  </div>
                </div>
              </div>
              <input
                type="hidden"
                formControlName="role"
                class="form-control"
                value="this.addUserForm.get('roleId').value"
                #hiddenRole
              />
              <input
                type="hidden"
                formControlName="id"
                value="this.addUserForm.get('id').value"
              />
            </form>
          </div>

          <div class="col-4 modalBodyAside">
            <p class="modify text-color text-uppercase modify-user">
              <b i18n="@@admin.users.title.manageuserroles"
                >modify user roles</b
              >
            </p>
            <div *ngFor="let role of userRole" class="row ml-2">
              <input
                value="{{ role.roleName }}"
                class="btn-role"
                type="button"
                [disabled]="!role.canSet"
                [ngClass]="
                  this.selectedRole.indexOf(role.roleName) === -1
                    ? 'btn btn-outline-primary'
                    : 'btn btn-outline-primary background-color'
                "
                (click)="getSelectedRole(role, $event)"
              />
            </div>
          </div>
        </div>
        <div class="modalFooter">
          <img
            src="assets/Keen&Wise_save.png"
            class="saveBtn waves-effect"
            (click)="updateUser()"
            id="editUser"
          />
        </div>
      </div>
    </div>
  </div>
</div>
